/**
 * SHA-256 of `napi11es:keeper:YYYY-MM-DD` as 64-char lowercase hex.
 * Uses the WebCrypto SubtleCrypto API (works in browsers, Workers, and Node 16+).
 * See spec §2.3.
 */
export async function dailySeedHash(date: string): Promise<string> {
  const input = `napi11es:keeper:${date}`;
  const bytes = new TextEncoder().encode(input);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return [...new Uint8Array(digest)]
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

/**
 * Extracts a 32-bit unsigned integer from the hex hash starting at the given
 * character offset (must be 0..56 to leave 8 hex chars = 32 bits available).
 */
export function seedToInt32(hash: string, offsetChars: number): number {
  if (offsetChars < 0 || offsetChars > hash.length - 8) {
    throw new RangeError(`seedToInt32 offset ${offsetChars} out of range for hash length ${hash.length}`);
  }
  return parseInt(hash.slice(offsetChars, offsetChars + 8), 16);
}
